"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DetailsColumn.types.js.map